import { useLocation, useParams } from "react-router";
import HeaderBackNav from "../../../components/header-back-navigation/HeaderBackNav";
import {
  // AppointmentMainIcon,
  CheckGreen,
  InfoIcon,
  OpenTask,
  RequestChnages,
  UserIcon,
} from "../../../assets/common-svg/CommonSvg";
import CustomAccordion from "../../../components/custom-accordion/CustomAccordion";
import { useEffect, useState } from "react";
import { FormView } from "../../../pages/form-template/create-form-template/FormView";
import CustomDrawer from "../../../components/custom-drawer/CustomDrawer";
import { FormCommentList } from "../../../components/form-template/FormCommentList";
import { FormValues } from "../../../components/form-template/FormValues";
import { CustomHeaderCard } from "../../../components/custom-header-card/CustomHeaderCard";
import { getUserHasAccess, hasAuthority } from "../../../utils/authorities";
import {
  Button,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import SkeletonLoader from "../../../utilites/SkeltonLoader";
import bmrSubjectApi from "../../services/bmrSubjectService";
import { useDispatch, useSelector } from "react-redux";
import {
  urlToBackWithoutState,
  calculateYears,
} from "../../../utilites/Common";
import NoDataCard from "../../../components/no-data-card";
import moment from "moment";
import SelectFormModel from "../../../components/custom-model/SelectFormModel";
import bmrQueryApi from "../../services/bmrQueryManage";
import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb";
import CustomDropdown from "../../../components/custom-dropdown/CustomDropdown";
import ConfirmationModal from "../../../components/modal-contents/ConfirmationModal";
import { GenderList, StatusChangeHeading } from "../../../utils/common";
import CustomModel from "../../../components/custom-model/CustomModel";
import {
  deadDateValue,
  EditSubjectPhase,
  FollowUpLostDateValue,
  patientIdValue,
  requestChangeInitial,
} from "../../../utils/formik/initialValues";
import {
  addPatientIdSchema,
  deathDateSchema,
  editSubjectPhaseValidationSchema,
  lostToFollowUpSchema,
  recordedDateSchema,
  requestModalDataSchema,
  apheresisDateRangeSchema,
} from "../../../utils/formik/validationSchema";
import bmrSubAdminApi from "../../services/bmrSubAdminApi";
import FeasibilityAlertWithModal from "../../components/features/FeasibiltyDetails/FeasibilityAlertWithModal";
import { updateScheduleApheresis } from "../../slices/feasibility";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import PreScreenForm from "../../../pages/appointment-details/PreScreenForm";
import ListAssignedPM from "../../../pages/appointment-details/common-in-bound/listAssignPM"
import {
  clinicalStatus,
  financialStatus,
} from "../../../pages/appointment-details/common-pre-screen/common";
import { clearSlugs, setSlugs, setSechedule, clearSechedule } from "../../slices/help";
import ToolTipContent from "../../../pages/appointment-details/common-pre-screen/TooltipContent";
import SingleToolTip from "../../../pages/appointment-details/common-pre-screen/SingleTooltip";
import { dateFormater } from "../../utils/common/utils";
import ChatModule from "../Chat";
import { addPatientList, addPhaseList } from "../../slices/chat";
import { notify } from "../../utils/methods/notification";
import { formatDateMoment,buildAssigneeList} from "../../../utils/utils"
import FilePreviewModal from "../../../bmr/components/common/FilePreview"
import DownloadImageApi from "../../../services/downloadImageService"
import RequestHistory from "./RequestHistory"

export const BmrAppointmentDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation()
  const [deadValue, setDeadValue] = useState(deadDateValue);
  const [followUpValue, setFollowUpValue] = useState(FollowUpLostDateValue);
  const [lifeStatusValue, setLifeStatusValue] = useState("");
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const userAuthority = LoginData?.auth || [];
  const role_id = LoginData?.role_id;
  const role_slug = LoginData?.role_slug;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [filePreview, setFilePreview] = useState("");
  const [lastQrId, setLastQrId] = useState("");


  const AssignedFormDataList = useSelector(
    (state) => state?.phaseReducer.asignedFormTemplate
  );
  const [recordedDateModel, setRecordedDateModel] = useState(false);
  const [recordedDate, setRecordedDate] = useState(null);
  const [SubjectData, setSubjectData] = useState({});
  const [lifeValue, setLifeValue] = useState("");
  const [selectedLifeValue, setSelectedLifeValue] = useState("");
  const [, setRequestReasonMenu] = useState([]);
  const [recordCurrentInfo, setRecordCurrentInfo] = useState([]);
  const [isRequestChangeModal, setIsRequestChangeModal] = useState(false);
  const [patientId, setPatientId] = useState(""); // This would be removed when setting from api.
  const [openDateModal, setOpenDateModal] = useState(false);
  const [openAddPatientIdModal, setOpenAddPatientIdModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [breadCrumbArray] = useState(
    urlToBackWithoutState(location.pathname, location?.state )
  );
  const [isApheresisModal, setIsApheresisModal] = useState(false);
  const [apheresisDateRange, setApheresisDateRange] = useState({});

  const [queryLoading, setQueryLoading] = useState(false);
  const [openAppointmentModel, setOpenAppointmentModel] = useState(false);
  const [isFormLoading, SetIsFormLoading] = useState(false);
  const [accordionData, setAccordionData] = useState([]);
  const [openConfirmStausChange, setOpenConfirmStausChange] = useState(false);
  const [formTemplateList, setFormTemplateList] = useState([]);
  const [taskTimelineOpen, setTaskTimelineOpen] = useState(false);
  const [taskTimelineData, setTaskTimelineData] = useState([]);
  const [editPatientModelOpen, setEditPatientModelOpen] = useState(false);
  const [editSubjectPatient, setEditSubjectPatient] =
    useState(EditSubjectPhase);
  const [apheresisDatesFlag, setApheresisDatesFlag] = useState(false);
  const clinicalPermissionStatus =
    hasAuthority(["marked-clinical-feasible"], bmr_permissions) &&
    SubjectData?.feasibility_assessments?.clinical_status !== 0;
  const financialPermissionStatus =
    hasAuthority(["marked-financial-feasible"], bmr_permissions) &&
    SubjectData?.feasibility_assessments?.financial_status != 0;
  const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
  const [editorDrawerData, setEditorDrawerData] = useState([]);
  const addVisitActive = !["dead", "lost", "lost to follow up"].includes(SubjectData?.life_status?.toLowerCase()?.trim()) && 
    (!SubjectData?.prescreen_form || SubjectData?.prescreen_form == null)  &&
    ((SubjectData?.last_appointment_date && SubjectData?.title) ||
   (SubjectData?.title && SubjectData?.created_at))

 const handleOpenEditorDrawer = () => {
  const list = buildAssigneeList(SubjectData);
  setEditorDrawerData(list);
  setOpenEditorDrawer(true);
};

 useEffect(() => {
    return () => {
      dispatch(clearSlugs());
      dispatch(clearSechedule(false))    
    };
  }, []);

  const [editPatientModelData, setEditPatientModelData] = useState({
    title: "Edit Patient",
    editTitle: "Edit Patient",
    children: [
      {
        type: "input",
        name: "first_name",
        label: "First Name",
        placeholder: "Enter First Name",
        IsRequired: true,
      },
      {
        type: "input",
        name: "last_name",
        label: "Last Name",
        placeholder: "Enter Last Name",
        IsRequired: true,
      },
      {
        type: "dropdown",
        name: "gender",
        label: "Gender",
        placeholder: "Select gender",
        data: [],
        IsRequired: true,
      },
      {
        type: "input",
        name: "investigator_id",
        label: "Principal Investigator",
        placeholder: "Select principal investigator",
        data: [],
        IsRequired: true,
        disabled: true,
      },
      {
        type: "input",
        name: "editor_id",
        label: "Editor",
        placeholder: "Select Editor",
        data: [],
        IsRequired: true,
        disabled: true,
      },
      {
        type: "input",
        name: "disease_id",
        label: "Disease",
        placeholder: "Select disease",
        data: [],
        IsRequired: true,
        disabled: true,
      },
      {
        type: "date",
        name: "dob",
        label: "Date of Birth",
        placeholder: "Select Date",
        minDate: false,
        maxDate: new Date(),
        IsRequired: true,
      },
    ],
  });

  const [queryData, setQueryData] = useState([
    {
      title: "Relapsed/Refractory",
      leftBorder: false,
      backgroundColor: "#F0F1F5",
      color: "#000000",
      expanded: false,
      menuData: [
        {
          title: "Aman Sharma Max Hospital (PI)",
          name: "AS",
          describe: "Is sugar test done empty stomach ?",
          date: "05/04/2024",
        },
      ],
      previous_value: [],
    },
  ]);

  const [dateModelData, setDateModelData] = useState({
    title: "Add Date",
    children: [],
  });

  const [requestModalData, setRequestModalData] = useState({
    title: "Request To Update",
    children: [],
  });

  const [addIdModelData] = useState({
    title: "Add Patient Id",
    children: [
      {
        type: "input",
        name: "patientId",
        label:
          "Ensure that the entered Patient ID is same as received from ImmunoACT",
        placeholder: "Enter Patient Id",
        IsRequired: true,
      },
    ],
  });

   const handleDownload = async (id) => {
        try {
          const imgRes = await DownloadImageApi.getDownloadedImageul(id);
          const response = await fetch(imgRes?.data || "");
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          setFilePreview(response?.url);
          setPreviewOpen(true);
          return true
        } catch (error) {
          // console.error("Download failed:", error);
          console.log("Download failed. Please try again later.");
        }
      };

  const feasibilityType =
    useSelector((state) => state?.operation?.operationTitle) || "";
  const getSubjectDetails = async () => {
    try {
      const res = await bmrSubjectApi.getSubjectDetails(id);
      setSubjectData(res?.data);
      setLifeValue(
        res?.data?.life_status?.toLowerCase() == "lost"
          ? "lost_to_follow_up"
          : res?.data?.life_status?.toLowerCase() || ""
      );
      setPatientId(res?.data?.patient_id);
      // @info set slugs in redux for FAQ
      if (role_id === 5 || role_slug === "project-manager") {
        dispatch(setSlugs(["pre-screening-process", "schedule-apheresis"]));
      } else if (clinicalPermissionStatus) {
        dispatch(setSlugs(["pre-screening-process", "clinical-feasibility"]));
      } else if (financialPermissionStatus) {
        dispatch(setSlugs(["pre-screening-process", "financial-feasibility"]));
      }
      let accData = [];
      res?.data?.appointment_details?.map((op) => {
        let obj = {};
        obj.title = op?.title;
        if (
          op?.appointment_answer?.appointment_answer_status == "in-progress"
        ) {
          obj.status = [
            {
              icon: <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />,
              text: "In Progress",
              color: "#FB9D2C",
            },
          ];
          obj.color = "#FB9D2C";
        } else if (
          op?.appointment_answer?.appointment_answer_status == "completed"
        ) {
          obj.status = [
            {
              icon: <CheckGreen Filled="#00B278" />,
              text: "Completed",
              color: "#00B278",
            },
          ];
          obj.color = "#00B278";
        } else {
          obj.status = [
            {
              icon: <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />,
              text: "In Progress",
              color: "#FB9D2C",
            },
          ];
          obj.color = "#FB9D2C";
        }
        if (op?.appointment_answer?.type) {
          obj.type = op?.appointment_answer?.type;
        }
        if (op?.totalQueryCount > 0) {
          obj.status = [
            ...obj.status,
            {
              icon: (
                <div className="border-l-2 ">
                  <Typography
                    variant="body1"
                    className="ml-2 rounded-3xl text-center align-self-center  text-[0.8rem] w-[1.2rem] h-[1.2rem] text-white bg-[#FF0000]"
                  >
                    {op?.totalQueryCount}
                  </Typography>
                </div>
              ),
              text: "Query Raised",
              color: "#FF0000",
            },
          ];
        }
        obj.appointment_answer_id = op?.appointment_answer?.id;
        obj.appointment_id = op?.id;
        obj.query = 3;
        obj.leftBorder = true;
        obj.expanded = false;
        accData.push(obj);
      });
      setAccordionData(accData);
    } catch (error) {
     notify.error(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getSubjectDetails();
    getStatusDropDown();
    // handleGetHistory();
  }, [!accordionData && accordionData.length == 0]);

  useEffect(() => {
    if (apheresisDateRange.from && apheresisDateRange.to) {
      setApheresisDatesFlag(true);
    } else {
      setApheresisDatesFlag(false);
    }
  }, [apheresisDateRange]);

  useEffect(() => {
    if (
      SubjectData?.feasibility_assessments?.apheresis_from_date &&
      SubjectData?.feasibility_assessments?.apheresis_to_date
    ) {
      setApheresisDatesFlag(true);
    } else {
      setApheresisDatesFlag(false);
    }
  }, [SubjectData]);

  // useEffect(() => {
  //   if (
  //     SubjectData?.appointment_details?.length > 0 &&
  //     SubjectData.appointment_details[0].status === "In Progress"
  //   ) {
  //     setIsAppointmentInProgress(true);
  //   } else {
  //     setIsAppointmentInProgress(false);
  //   }
  // }, [SubjectData]);

  const handleExpansion = (index) => {
    let s1 = [...accordionData];
    if (s1[index] && s1[index].expanded !== undefined) {
      s1[index].expanded = !s1[index].expanded;
    }
    setAccordionData(s1);
  };

  const onMarkAsFisable = () => {
    getSubjectDetails();
  };

  const getQueryHistory = async (id, version) => {
    setQueryLoading(true);
    try {
      const res = await bmrQueryApi.getAllQueryHistory(id, version);
      if (res?.data && res?.data.length != 0) {
        let data = res?.data.map((op) => {
          return {
            title: op.field_name,
            leftBorder: false,
            backgroundColor: "#F0F1F5",
            color: "#000000",
            expanded: false,
            menuData: op.appointment_queries_replies.map((op) => {
              return {
                title: `${op.user_name} (${op.role})`,
                name: `${op.user_name[0]}${op.user_name[1]}`,
                describe: op.query,
                date: op.created_at,
              };
            }),
            values: {
              previous_value: op.previous_answer_value,
              new_value: op.new_answer_value,
            },
          };
        });
        toggleDrawer();
        // setDrawerTitle("");
        setQueryData(data);
      } else {
        setQueryData([]);
        notify.error(res?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setQueryLoading(false);
    }
  };

  const handleChangeForm = (data, index, name) => {
    let s1 = [...accordionData];
    s1[index][name] = data;
    setAccordionData(s1);
  };

  const handleAddAppointmentModel = async (values) => {
    SetIsFormLoading(true); // Reset loading state
    setRecordedDateModel(true);
    setRecordedDate({ ...values, last_recorded_visit_date: "" });
    setDateModelData((prev) => ({
      ...prev,
      title: "Add Date",
      children: [
        {
          type: "date",
          name: "last_recorded_visit_date",
          label: "Last Recorded Visit Date",
          placeholder: "Select Date",
          minDate: false,
          maxDate: new Date(),
          IsRequired: true,
        },
      ],
    }));
    setOpenAppointmentModel(false);
    SetIsFormLoading(false); // Reset loading state
  };

  const handleRecordingDate = async (data) => {
    setButtonLoading(true);
    let updatedValues = {
      title: data.form.title,
      form_template_id: data.form.id || 0,
      phase_id: SubjectData.phase_id,
      subject_id: SubjectData.id,
      last_recorded_visit_date: data.last_recorded_visit_date,
    };

    try {
      // API call to add phase
      const response = await bmrSubjectApi.addAppointment(updatedValues);

      await getSubjectDetails();
      // window.location.reload();
      // Dispatch success snackbar message
      notify.success(response.message || "Appointment added successfully")
    } catch (error) {
      notify.error(error?.message || error || "Failed to add appointment")
    } finally {
      setButtonLoading(false);
      setRecordedDateModel(false); // Reset loading state
    }
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleTaskTimelineDrawer = () => {
    // setHistoryOpen(!historyOpen);
    handleGetTaskTimelineData();
  };

  const handleGetTaskTimelineData = async () => {
    const payload = {
      subject_id: SubjectData.id,
      phase_id: SubjectData.phase_id,
      page: 1,
      limit: 10,
    };

    try {
      // Pass integers and actual null values
      const response = await bmrSubjectApi.taskTimeline(
        payload.subject_id,
        payload.limit,
        payload.page,
        {
          phase_id: payload.phase_id,
          sort_by: null,
        }
      );

      if (response.data.length > 0) {
        setTaskTimelineOpen(!taskTimelineOpen);
        setTaskTimelineData(response.data);
      } else {
        notify.error(response.message)
      }
    } catch (error) {
       notify.error(error?.message || error || "Failed to load task timeline")
    }
  };
  // Helper function to get status color and text
  const getStatusInfo = (status) => {
    return status === 1
      ? { color: "success", text: "Completed", chipColor: "success" }
      : { color: "warning", text: "Open", chipColor: "warning" };
  };

  const handleCompleteTask = async (taskId) => {
    try {
      await bmrSubjectApi.completeTask(taskId);

      // Show success message
       notify.success("Task completed successfully!")
      // Refresh the task timeline data after completing the task
      handleGetTaskTimelineData();
    } catch (error) {
      console.error("Error completing task:", error);
      // Show error message
      notify.error(error?.message || error || "Failed to complete task")
    }
  };

  const handleQuery = (index) => {
    let s1 = [...queryData];
    if (s1[index] && s1[index].expanded !== undefined) {
      s1[index].expanded = !s1[index].expanded;
    }
    setQueryData(s1);
  };

  const findFormTypeID = (form_template_id) =>
    AssignedFormDataList?.find(
      (item) => Number(item.type.id) === Number(form_template_id)
    )?.id;

  const handleAddAppointment = async () => {
    try {
      const res = await bmrSubAdminApi?.formTemplateOrderwise({
        subject_id: SubjectData.id,
        phase_id: SubjectData.phase_id,
      });

      if (res?.data?.length > 0) {
        const dataUpdated =
          res?.data?.map((item) => ({
            id: item?.form_template_id || findFormTypeID(item?.id),
            title: item?.name,
          })) || [];
        setFormTemplateList(dataUpdated);
        setOpenAppointmentModel(true);
      } else {
        notify.error("Required numbers of visits have been recorded")
      }
    } catch (error) {
       notify.error(error);
    }
  };


  const handleApheresisDateRangeSubmit = async (values) => {
    try {
      setButtonLoading(true);

      const data = {
        id: SubjectData?.feasibility_assessments?.id,
        apheresis_from_date: moment(
          values?.apheresisDateRange?.from,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD HH:mm:ss"),
        apheresis_to_date: moment(
          values?.apheresisDateRange?.to,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD HH:mm:ss"),
      };

      const scheduleApheresis = await dispatch(
        updateScheduleApheresis(data)
      ).unwrap();
      if(scheduleApheresis.status){
      notify.success(scheduleApheresis.message)
      }else{
      notify.error(scheduleApheresis.message)
      }

      if (scheduleApheresis.status) {
        getSubjectDetails();
      }

      setApheresisDateRange(values.apheresisDateRange); // Update the date range state
      setOpenDateModal(false); // Close the modal
      setIsApheresisModal(false); // Reset the flag
    } catch (error) {
      console.error("Error in handleApheresisDateRangeSubmit:", error);
    } finally {
      setButtonLoading(false);
    }
  };

    useEffect(() =>{
                    const scheduleCondition = ((lifeValue === "alive" &&
                  !SubjectData?.feasibility_assessments?.requested_date &&
                  !SubjectData?.feasibility_assessments?.apheresis_date &&
                  (role_id == 5 ||  role_slug === "project-manager")  &&
                  !apheresisDatesFlag) ||
                  (role_id === 1 &&
                    feasibilityType ===
                    "change-scheduled-aphresis-date-range"))
                    console.log(scheduleCondition)
                      dispatch(setSechedule(scheduleCondition))
    },[lifeValue,SubjectData,apheresisDatesFlag,feasibilityType,role_id,role_slug])

  const handleSelectFormError = (error) => {
     notify.error(error)
  };

  const patientLifeMenu = [
    { id: "alive", name: "Alive" },
    { id: "dead", name: "Dead" },
    { id: "lost_to_follow_up", name: "Lost to Follow Up" },
  ];

  const handlePatientLife = async (data) => {
    setButtonLoading(true);
    let statusChangeDate =
      selectedLifeValue == "dead"
        ? moment(data?.deathDateValue).format("DD/MM/YYYY")
        : moment(data?.lostToFollowUp).format("DD/MM/YYYY");
    try {
      let payload =
        selectedLifeValue == "alive" || !data
          ? {
            subject_id: SubjectData?.id,
            life_status: "alive",
          }
          : {
            subject_id: SubjectData?.id,
            life_status:
              selectedLifeValue == "dead" ? selectedLifeValue : "lost",
            status_change_date: statusChangeDate,
            description: data.description ? data.description : "",
          };
      const res = await bmrSubjectApi.changeLifeStatus(payload);
      if (res.status) {
        getSubjectDetails();
         notify.success(res?.message)
      } else {
       notify.error(res?.message) 
      }
    } catch (error) {
      console.error("Error changing life status:", error);
        notify.error(error) 
    } finally {
      setButtonLoading(false);
      setOpenDateModal(false);
      setDateModelData((prev) => ({ ...prev, children: [] }));
    }
  };

  const handleAddPatientId = async (data) => {
    setButtonLoading(true);
    try {
      const res = await bmrSubjectApi.addPatientId({
        subject_id: SubjectData?.id,
        patient_id: data?.patientId,
      });
      if (res.status) {
        getSubjectDetails();
          notify.success(res.message)
      }
    } catch (error) {
        notify.error(error)
    } finally {
      setOpenAddPatientIdModal(false);
      setButtonLoading(false);
    }
  };

  const toggleDateModal = () => {
    setOpenDateModal(true);
  };

  const handleStatusChangeConfirmation = (confirmationResult) => {
    if (confirmationResult) {
      setOpenConfirmStausChange(false);
      if (lifeStatusValue !== "alive") {
        toggleDateModal();
      } else {
        handlePatientLife();
      }
    } else {
      setOpenConfirmStausChange(false);
      setSelectedLifeValue(""); // selected value to be empty when No button is clicked
      setDateModelData((prev) => ({ ...prev, children: [] })); //SetModal Children to be empty
      //Repeat the same above when api process is completed  either in response/error encounter.
    }
  };

  const handleOpenConfirmModal = (value, confirmModel) => {
    setLifeStatusValue(value);
    confirmModel
      ? setOpenConfirmStausChange(true)
      : value != "alive"
        ? toggleDateModal()
        : "";
    setSelectedLifeValue(value);
    if (value == "dead") {
      if (!confirmModel) {
        setDeadValue({
          deathDateValue: moment(
            SubjectData.status_change_date,
            "DD/MM/YYYY"
          ).format("MM/DD/YYYY"),
        });
      }
      setDateModelData((prev) => ({
        ...prev,
        title: confirmModel ? "Add Date" : "Edit Date",
        children: [
          {
            type: "date",
            name: "deathDateValue",
            label: "Date of Death",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
          {
            type: "input",
            name: "description",
            label: "Enter Description",
            placeholder: "Enter Description",
            IsRequired: true,
          },
        ],
      }));
    } else if (value == "lost_to_follow_up") {
      if (!confirmModel) {
        setFollowUpValue({
          lostToFollowUp: moment(
            SubjectData.status_change_date,
            "DD/MM/YYYY"
          ).format("MM/DD/YYYY"),
        });
      }
      setDateModelData((prev) => ({
        ...prev,
        title: confirmModel ? "Add Date" : "Edit Date",
        children: [
          {
            type: "date",
            name: "lostToFollowUp",
            label: "Date of Last Follow Up",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
          {
            type: "input",
            name: "description",
            label: "Enter Description",
            placeholder: "Enter Description",
            IsRequired: false,
          },
        ],
      }));
    }
  };

  const handleStatusChange = (selectedValue) => {
    const reasonInfoDetail = recordCurrentInfo.data?.find(
      (item) => item.id === selectedValue
    );

    if (reasonInfoDetail) {
      const getRequestReasonSlugs = (item) => {
        if (reasonInfoDetail.slug === "feasibility-assessment") {
          if (role_id === 5 ||  role_slug === "project-manager") {
            return item.slug == "change-scheduled-aphresis-date-range";
          }
          if (
            clinicalPermissionStatus &&
            item.slug == "change-clinical-feasibility"
          ) {
            return true;
          }
          if (
            financialPermissionStatus &&
            item.slug == "change-financial-feasibility"
          ) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      };
      const updatedMenu = reasonInfoDetail.children
        .filter(getRequestReasonSlugs)
        .map((item) => ({ id: item.id, name: item.title }));
      setRequestModalData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "Select_patient_Info_menu"
            ? {
              ...child,
              data: updatedMenu,
              type:
                reasonInfoDetail.slug === "demographics"
                  ? "multidropdown"
                  : "dropdown",
            }
            : child
        ),
      }));
    }
  };

  const handleOpenRequestModal = async () => {
    const reasonMenu = await getStatusDropDown();

    const filteredData =
      (role_id == 5 ||  role_slug === "project-manager") && SubjectData?.life_status === "alive"
        ? reasonMenu.filter((item) => item.name !== "Survival Status")
        : clinicalPermissionStatus || financialPermissionStatus
          ? reasonMenu.filter((item) => item.name == "Feasibility Assessment")
          : reasonMenu;

    setIsRequestChangeModal(true);
     const filterResult = (SubjectData?.feasibility_assessments?.requested_date &&
                  SubjectData?.feasibility_assessments?.apheresis_date)
              ? filteredData.filter(
                (item) => item.slug != "feasibility-assessment"
              ): filteredData;
    setRequestModalData((prev) => ({
      ...prev,
      title: "Request To Update",
      children: [
        {
          type: "dropdown",
          name: "Select_patient_request_status",
          label: "Select Patient's Request Reason",
          placeholder: "Select Patient's Request Status",
          IsRequired: true,
          data:filterResult
        },
        {
          type: "dropdown",
          name: "Select_patient_Info_menu",
          label: "Select Patient's Info Reason",
          placeholder: "Select Patient's Info Reason",
          IsRequired: true,
          data: [],
        },
        {
          type: "description",
          name: "description",
          label: "Reason For Change", //@info update name of description to Reason for change
          placeholder: "Reason For Change",
          IsRequired: true,
        },
      ],
    }));
  };

  const handleRequestChangeSubmit = async (data) => {
    let convertPatientInfo = data.Select_patient_Info_menu.toString();
    try {
      let payload = {
        change_request_reason_id: data.Select_patient_request_status,
        change_request_reason_value_id: convertPatientInfo,
        description: data.description,
        subject_id: SubjectData.id,
        phase_id: SubjectData.phase_id,
      };
      const res = await bmrSubjectApi.requestChange(payload);
      if (res.status === 200) {
      notify.success(res?.message)
        setIsRequestChangeModal(false);
      }
    } catch (error) {
      setIsRequestChangeModal(false);
       notify.error(error?.[0]?.description)
    }
  };
  // Function to get Reason Dropdown
  const getStatusDropDown = async () => {
    try {
      const res = await bmrSubjectApi.getAllRequest();
      setRecordCurrentInfo(res);
      if (SubjectData?.life_status === "alive") {
        const result = res.data
          .filter((item) => item.title !== "Survival Status" && item.slug !== 'change-terminate-cycle-status')
          .map((item) => ({
            id: item.id,
            name: item.title,
            slug: item.slug
          }));
        setRequestReasonMenu(result);
        return result;
      } else {
        const result = res.data
          .filter((item) => item.slug !== 'change-terminate-cycle-status')
          .map((item) => ({
          id: item.id,
          name: item.title,
          slug: item.slug
        }));
        setRequestReasonMenu(result);
        return result;
      }
    } catch (error) {
      notify.error(error)
    }
  };

  const handleEditIcon = () => {
    let s1 = { ...editSubjectPatient }; // Shallow copy

    setEditPatientModelOpen(true);

    // Create a deep copy of SubjectData to avoid reference issues
    s1 = JSON.parse(JSON.stringify(SubjectData));

    s1.investigator_id = SubjectData?.investigator?.name;
    s1.editor_id = SubjectData?.editor?.name;
    s1.gender =
      SubjectData?.gender === "Male"
        ? 1
        : SubjectData?.gender === "Female"
          ? 2
          : 3;
    s1.disease_id = SubjectData?.disease?.name;

    setEditPatientModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "gender" ? { ...child, data: GenderList } : child
      ),
    }));

    setEditSubjectPatient(s1); // Updating state with deep-copied and modified data
  };

  const handleEditPatient = async (values) => {
    try {
      const payload = {
        first_name: values?.first_name,
        last_name: values?.last_name,
        gender: GenderList.find((op) => op.id == values.gender).name, // Use the awaited gender value
        dob: values?.dob,
        editor_id: values?.editor?.id,
        investigator_id: values?.investigator?.id,
        disease_id: values?.disease?.id,
        phase_id: values?.phase_id,
        phase_code: values?.phase_details?.phase_code,
        phase_title: values?.phase_details?.title,
      };
      const response = await bmrSubjectApi.editPatient(payload, values?.id);
       notify.success(response.message || "Patient Edited Successfully")
      await getSubjectDetails();
    } catch (error) {
      notify.error(error.message || error || "Failed to Edit Patient")
    } finally {
      setEditPatientModelOpen(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getSubjectDetails();
    getStatusDropDown();
    // handleGetHistoryData()
  }, [!accordionData && accordionData.length == 0, id]);
  useEffect(() => {
    return () => {
      dispatch(clearSlugs());
    };
  }, []);


 ////////// phase and pantient List for chat bot ///////////
 
   useEffect(() => {
         const nonEmptyQrCodes = SubjectData?.feasibilityAssessments?.filter(item => item?.qr_code_generations?.length > 0);
     const lastQrCodeId = nonEmptyQrCodes?.[nonEmptyQrCodes?.length - 1]?.qr_code_generations[0]?.id;
   setLastQrId(lastQrCodeId)

     const phaseList = [{ value: SubjectData?.phase_details?.id, label: `${SubjectData?.phase_details?.title} (${SubjectData?.phase_details?.product_details?.name})`, patient_id: SubjectData?.id }]
     const patientList = [{ value: SubjectData?.id, label: `${SubjectData?.first_name}  ${SubjectData?.last_name}`, phase_id: SubjectData?.phase_details?.id }]
     dispatch(addPatientList(patientList))
     dispatch(addPhaseList(phaseList))

  
   }, [SubjectData])
 
   ////////////////////////////////////////////////////////////
  return (
    <div className="p-3 flex flex-col gap-4 mt-4">
      <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
      <SelectFormModel
        open={openAppointmentModel}
        setOpen={setOpenAppointmentModel}
        isFormLoading={isFormLoading}
        data={formTemplateList}
        SetIsFormLoading={SetIsFormLoading}
        handleValue={handleAddAppointmentModel}
        handleError={handleSelectFormError}
      />
      <div className="flex flex-col gap-4  ">
        <div className="flex flex-col lg:col-start-4 lg: col-end-13 sm:col-start-1 sm:col-end-13">
          <CustomHeaderCard
            editIcon={true}
            handleEditIcon={handleEditIcon} 
             SubjectData={{
                          phase_id: SubjectData?.phase_id,
                          id: SubjectData?.id,
                          qr_code:lastQrId,
                          code: SubjectData?.patient_id,
                          gender: SubjectData?.gender,
                          age: calculateYears(SubjectData?.dob),
                        }}
            DetailsArray={[
              { FieldName: "Patient Id", Value: patientId || "- -" },
              {
                FieldName: "Patient Status",
                icon: {
                  name: "Edit",
                  auth: 162,
                  value: lifeValue,
                  status:
                    lifeValue == "lost_to_follow_up" || lifeValue == "dead"
                      ? true
                      : false,
                  type: "edit",
                  toolText: "Edit the date",
                  event: handleOpenConfirmModal,
                },
                Value:
                  lifeValue == "lost_to_follow_up"
                    ? `Lost To Follow Up ${SubjectData?.status_change_date
                      ? `(${SubjectData?.status_change_date})`
                      : ""
                    }`
                    : lifeValue == "dead"
                      ? `Dead ${SubjectData?.status_change_date
                        ? `(${SubjectData?.status_change_date})`
                        : ""
                      }`
                      : lifeValue,
              },
              {
                FieldName: "Date of Birth",
                Value: moment(SubjectData?.dob).format("DD/MM/YYYY"),
              },

              ...[
               (role_id == 5 ||  role_slug === "project-manager")  && {
                  FieldName: "Feasibility",
                  Value:
                    SubjectData?.feasible_status == "Feasible" ? (
                      <Tooltip
                        title={
                          <ToolTipContent
                            data={SubjectData?.feasibility_assessments}
                          />
                        }
                        arrow
                        placement="right"
                        sx={{
                          pointerEvents: "painted",
                          "& .MuiTooltip-tooltip": {
                            maxWidth: { xs: 300, sm: 400 },
                          },
                        }}
                        enterDelay={200}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              padding: 0,
                              minWidth: { xs: 300, sm: 400 },
                              borderRadius: "0.95rem",
                              bgcolor: "white",
                              color: "text.primary",
                              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                              position: "relative",
                            },
                            className: "custom-tooltip",
                          },
                          arrow: {
                            sx: {
                              left: 0,
                              marginLeft: "-2.1em !important",
                              height: "2.5rem  !important",
                              width: "2.71em !important",
                              color: "white",
                              "&:before": {
                                // boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.2)',
                              },
                            },
                          },
                        }}
                      >
                        <Chip
                          label={SubjectData?.feasible_status}
                          color={
                            SubjectData?.feasible_status == "Pending"
                              ? "warning"
                              : SubjectData?.feasible_status == "Feasible"
                                ? "success"
                                : "default"
                          }
                        />
                      </Tooltip>
                    ) : (
                      <Chip
                        label={SubjectData?.feasible_status}
                        color={
                          SubjectData?.feasible_status == "Pending"
                            ? "warning"
                            : SubjectData?.feasible_status == "Feasible"
                              ? "success"
                              : "default"
                        }
                      />
                    ),
                },
              ],
              ...(hasAuthority(
                ["marked-clinical-feasible", "marked-financial-feasible"],
                bmr_permissions
              ) &&
                (SubjectData?.feasibility_assessments?.clinical_status != null ||
                  SubjectData?.feasibility_assessments?.financial_status != null)
                ? [
                  {
                    FieldName: "Clinical Feasibility",
                    Value:
                      SubjectData?.feasibility_assessments?.clinical_status ==
                        0 ? (
                        <Chip
                          label={
                            clinicalStatus[
                              SubjectData?.feasibility_assessments
                                ?.clinical_status
                            ]?.lable
                          }
                          color={
                            clinicalStatus[
                              SubjectData?.feasibility_assessments
                                ?.clinical_status
                            ]?.color
                          }
                        />
                      ) : (
                        <Tooltip
                          title={
                            <SingleToolTip
                              row={SubjectData?.feasibility_assessments}
                              approvedBy={
                                SubjectData?.feasibility_assessments
                                  ?.clinical_by?.name
                              }
                              feasibility={clinicalStatus}
                              status={
                                SubjectData?.feasibility_assessments
                                  ?.clinical_status
                              }
                              comment={
                                SubjectData?.feasibility_assessments
                                  ?.clinical_feasibility_comment
                              }
                              media={
                                 SubjectData?.feasibility_assessments?.clinical_media?.length > 0 ? 
                                 SubjectData?.feasibility_assessments?.clinical_media
                                  :[]}
                              title={"Clinical Feasibility"}
                              handleDownload={handleDownload}
                            />
                          }
                          arrow
                          placement="right"
                          sx={{
                            pointerEvents: "painted",
                            "& .MuiTooltip-tooltip": {
                              maxWidth: { xs: 300, sm: 400 },
                            },
                          }}
                          enterDelay={200}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                padding: 0,
                                minWidth: { xs: 300, sm: 400 },
                                borderRadius: "0.95rem",
                                bgcolor: "white",
                                color: "text.primary",
                                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                                position: "relative",
                              },
                              className: "custom-tooltip",
                            },
                            arrow: {
                              sx: {
                                left: 0,
                                marginLeft: "-2.1em",
                                height: "2.1rem",
                                width: "2.71em",
                                color: "white",
                                "&:before": {
                                  // boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.2)',
                                },
                              },
                            },
                          }}
                        >
                          <Chip
                            label={
                              clinicalStatus[
                                SubjectData?.feasibility_assessments
                                  ?.clinical_status
                              ]?.lable
                            }
                            color={
                              clinicalStatus[
                                SubjectData?.feasibility_assessments
                                  ?.clinical_status
                              ]?.color
                            }
                          />
                        </Tooltip>
                      ),
                  },
                  {
                    FieldName: "Financial Feasibility",
                    Value:
                      SubjectData?.feasibility_assessments
                        ?.financial_status == 0 ? (
                        <Chip
                          label={
                            financialStatus[
                              SubjectData?.feasibility_assessments
                                ?.financial_status
                            ]?.lable
                          }
                          color={
                            financialStatus[
                              SubjectData?.feasibility_assessments
                                ?.financial_status
                            ]?.color
                          }
                        />
                      ) : (
                        <Tooltip
                          title={
                            <SingleToolTip
                              row={SubjectData?.feasibility_assessments}
                              approvedBy={
                                SubjectData?.feasibility_assessments
                                  ?.financial_by?.name
                              }
                              feasibility={financialStatus}
                              status={
                                SubjectData?.feasibility_assessments
                                  ?.financial_status
                              }
                              comment={
                                SubjectData?.feasibility_assessments
                                  ?.financial_feasibility_comment
                              }
                               media={
                                 SubjectData?.feasibility_assessments?.financial_media?.length > 0 ? 
                                 SubjectData?.feasibility_assessments?.financial_media
                                  :[]
                              }
                              title={"Financial Feasibility"}
                              handleDownload={handleDownload}
                            />
                          }
                          arrow
                          placement="right"
                          sx={{
                            pointerEvents: "painted",
                            "& .MuiTooltip-tooltip": {
                              maxWidth: { xs: 300, sm: 400 },
                            },
                          }}
                          enterDelay={200}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                padding: 0,
                                minWidth: { xs: 300, sm: 400 },
                                borderRadius: "0.95rem",
                                bgcolor: "white",
                                color: "text.primary",
                                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                                position: "relative",
                              },
                              className: "custom-tooltip",
                            },
                            arrow: {
                              sx: {
                                left: 0,
                                marginLeft: "-2.1em",
                                height: "2.1rem",
                                width: "2.71em",
                                color: "white",
                                "&:before": {
                                  // boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.2)',
                                },
                              },
                            },
                          }}
                        >
                          <Chip
                            label={
                              financialStatus[
                                SubjectData?.feasibility_assessments
                                  ?.financial_status
                              ]?.lable
                            }
                            color={
                              financialStatus[
                                SubjectData?.feasibility_assessments
                                  ?.financial_status
                              ]?.color
                            }
                          />
                        </Tooltip>
                      ),
                  },
                ]
                : []),
              {
                FieldName: "Phase",
                Value: `${SubjectData?.phase_details?.phase_code} ${SubjectData?.phase_details?.title}`,
              },
              {
                FieldName: "Editor/Patient Navigators",
                Value:  <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenEditorDrawer();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "#3571FF",
                        }}
                      >
                        {(() => {
                          const editors = SubjectData?.userPi || [];
                          return editors.length > 1 
                            ? editors.length.toString() 
                            : (editors.length === 1) 
                              ? editors[0]?.name || "--" 
                              : "--";
                        })()}
                      </Typography>
                    </span>,
              },
              {
               FieldName: "Scheduled Apheresis Date",
                Value: <Chip size="large" color={'warning'} label={SubjectData?.patient_slots?.slot?.date ? formatDateMoment(SubjectData?.patient_slots?.slot?.date) : "No Confirmed Date"} />,
              },
              {
               FieldName: "Infusion Date",
                Value: <Chip size="large" color={'warning'} label={SubjectData?.feasibility_assessments?.infusion_date ? formatDateMoment(SubjectData?.feasibility_assessments?.infusion_date) : "No Infusion Date"} />,
              },
              {
                FieldName: "Principal Investigator",
                Value: SubjectData?.investigator?.name || "Not Assigned",
              },
              {
                FieldName: "Hospital Name",
                Value:
                  SubjectData?.pi_coordinator?.hospital_details?.name ||
                  "Not Assigned",
              },
            ].filter((op) => op)}
            startIcon={<UserIcon />}
            // endIcon={<AppointmentMainIcon />}
            loading={loading} 
          />
        </div>
        <div className="w-full">
            <div className="flex flex-col items-center bg-white pb-2 p-2 rounded-[0.625rem] gap-3 md:gap-0 sm:flex-row  justify-content-between pb-3">
            <div className="flex gap-2 items-end">
             {!loading &&  getUserHasAccess(userAuthority, "appointmentManager", 126) && (
                  <div className="min-w-[10rem]">
                    <CustomDropdown
                      MinWidth="12px"
                      DropDownlabel="Patient Life Status"
                      PlaceholderText="Select Patient's Life Status"
                      MenuList={patientLifeMenu}
                      handleChange={(e) =>
                        handleOpenConfirmModal(e.target.value, true)
                      }
                      value={lifeValue}
                      PlaceholderTextMenu={true}
                      disabled={(role_id == 5 ||  role_slug === "project-manager")  ? lifeValue !== "alive" : false}
                      className={
                        lifeValue !== "alive" ? "cursor-not-allowed" : ""
                      }
                    />
                  </div>
                )}
                {/* Add New Visit */}
                
                {!loading &&  getUserHasAccess(userAuthority, "appointmentManager", 122) && (
                  <Button
                    size="large"
                    onClick={() => handleAddAppointment()}
                    disabled={ addVisitActive ? !addVisitActive :
                      (lifeValue !== "alive" ||
                      !SubjectData.isAddNewVisit ||
                      !SubjectData?.prescreen_form?.id)
                    }
                    sx={{
                      cursor: lifeValue === "alive" ? "pointer" : "not-allowed",
                      minWidth: "7.375rem",
                      height: "3rem",          // match dropdown height
                      alignSelf: "flex-end",   // ✅ aligns with dropdown bottom
                    }}
                  >
                    Add New Visit
                  </Button>
                )}
                
                {/* Request Changes */}
                {!loading && role_id !== 1 &&
                  ((role_id == 5 ||  role_slug === "project-manager")  ||
                    (clinicalPermissionStatus || financialPermissionStatus)) && (
                    <Tooltip
                      arrow
                      placement="left"
                      title={"Request Changes"}
                      onClick={() => handleOpenRequestModal()}
                    >
                      <button
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <RequestChnages />
                      </button>
                    </Tooltip>
                  )}
            </div>
           <div className="flex gap-2">
             {/* Task Timeline*/}
                {!loading && role_id != 1 && (
                  <Tooltip
                    title="Task Timeline"
                    onClick={handleTaskTimelineDrawer}
                  >
                    <button className="cursor-pointer">
                      <OpenTask />
                    </button>
                  </Tooltip>
                )}
                {!loading && ((role_id == 5 ||  role_slug === "project-manager")  ||
                  clinicalPermissionStatus ||
                  financialPermissionStatus) && (
                  <RequestHistory SubjectData={SubjectData} /> 
                  )}
                  <div className="mt-2">
              <FeasibilityAlertWithModal
                id={SubjectData?.feasibility_assessments?.id}
                phase_type={SubjectData?.phase_details?.phase_type?.name}
                feasibilityStatus={SubjectData?.feasibility_assessments}
                onMarkAsFisable={onMarkAsFisable}
                feasibilityType={feasibilityType}
              />
              </div>
            </div>
          </div>

            <div className="overflow-y-auto max-h-[46.8rem] mt-3">
              <div className="mb-2 ">
                {
                  loading ? (
                    <SkeletonLoader rowCount={1} height={80} isTable={false} />
                  ) : (
                    <PreScreenForm
                      getSubjectDetails={getSubjectDetails}
                      patientData={SubjectData}
                      disabledAll={
                        SubjectData?.prescreen_form?.id && SubjectData?.prescreen_form?.status != 'draft' ? true : false
                      }
                    />
                  )
                  // disabledAll={SubjectData?.prescreen_form?.id || !getUserHasAccess(userAuthority, "appointmentManager", 122) ? true : false} />
                }
              </div>
              {/* <div className="mb-2">
                <Accordion className="w-100 mt-2" defaultExpanded={false}>
                  <AccordionSummary
                    expandIcon={
                      <div className="d-flex gap-3 align-items-center">
                        <DownIcon />
                      </div>
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <span className="font-bold text-[0.9rem]">
                      Vien-to-Vien Status
                    </span>.format("DD/MM/YYYY")
                  </AccordionSummary>
                  <AccordionDetails>
                    <ProgressTrackerfrom steps={initialSteps} />
                  </AccordionDetails>
                </Accordion>
              </div> */}

              {loading ? (
                <SkeletonLoader rowCount={5} height={80} isTable={false} />
              ) : (
                // : accordionData.length == 0 && (SubjectData?.prescreen_form?.id && !loading) ? (
                //   <div className="">
                //     <NoDataCard borderRadius={"0.3rem"} />
                //   </div>
                // )
                accordionData?.map((acc, index) => (
                  <FormView
                    key={acc.appointment_id}
                    acc={acc}
                    index={index}
                    getQueryHistory={getQueryHistory}
                    handleChangeForm={handleChangeForm}
                    queryLoading={queryLoading}
                    handleExpansion={handleExpansion}
                    SubjectData={SubjectData}
                    patientLifeValue={lifeValue}
                  />
                ))
              )}
            </div>
        </div>
      </div>
      <CustomDrawer open={open} toggleDrawer={toggleDrawer}>
        <div className="pl-4 pt-4 pr-4">
          <HeaderBackNav
            handleBackNav={toggleDrawer}
            TitleFontSize={"18px"}
            TitleFontWeight={700}
            Title={"Query History"}
          />
        </div>
        <hr />
        <div className="pl-4 pt-4 pr-4">
          {queryData?.length != 0 ? (
            queryData.map((query, index) => (
              <CustomAccordion
                key={index}
                accordionClassName={"w-[25rem] "}
                rootDivClass={"pb-3"}
                leftBorder={query?.leftBorder}
                index={index}
                expanded={query?.expanded}
                handleExpansion={handleQuery}
                color={query?.color}
                backgroundColor={query?.backgroundColor}
                title={query?.title}
              >
                <FormValues
                  leftLable={"Previous Value"}
                  leftValue={query?.values?.previous_value}
                  rightLable={"New Value"}
                  rightValue={query?.values?.new_value ?? "N/A"}
                />
                <hr className="pb-3" />
                <div>
                  <FormCommentList MenuData={query.menuData} />
                </div>
              </CustomAccordion>
            ))
          ) : (
            <div className="mt-4">
              <NoDataCard />
            </div>
          )}
        </div>
      </CustomDrawer>

      {/* task timeline drawer */}
      <CustomDrawer
        open={taskTimelineOpen}
        toggleDrawer={handleTaskTimelineDrawer}
      >
        <div className="px-6 py-4 w-full">
          <HeaderBackNav
            handleBackNav={handleTaskTimelineDrawer}
            TitleFontSize={"20px"}
            TitleFontWeight={700}
            Title={"Task Timeline"}
          />
        </div>

        <div className="px-6">
          {taskTimelineData?.length > 0 ? (
            taskTimelineData?.map((item, index) => {
              const statusInfo = getStatusInfo(item.status);

              return (
                <Timeline
                  key={index}
                  className="!max-w-none"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot color={statusInfo.color} />
                      {index !== taskTimelineData.length - 1 && (
                        <TimelineConnector
                          sx={{
                            bgcolor:
                              statusInfo.color === "success"
                                ? "#4caf50"
                                : statusInfo.color === "warning"
                                  ? "#ff9800"
                                  : "#f44336",
                          }}
                        />
                      )}
                    </TimelineSeparator>
                    <TimelineContent>
                      {/* Date Badge */}
                      <Chip
                        size="medium"
                        color={statusInfo.chipColor}
                        label={
                          item.created_at ? dateFormater(item.created_at) : "--"
                        }
                        sx={{ mb: 2 }}
                      />

                      <div className="bg-gray-100 p-2 rounded shadow-sm mb-2">
                        <div className="mb-4">
                          <Typography variant="h6" className="font-semibold">
                            {item?.subject?.phase?.product_details?.name || "-"}{" "}
                            <span className="text-gray-500 font-normal ml-2">
                              ({item?.subject?.phase?.title || "-"})
                            </span>
                          </Typography>
                        </div>

                        <div className="grid grid-cols-2 gap-48 mb-3">
                          <Typography variant="body1" sx={{ color: "#666666" }}>
                            Patient ID:{" "}
                            <span style={{ color: "#000000" }}>
                              {item?.subject?.patient_id || "-"}
                            </span>
                          </Typography>
                          <Typography variant="body1" sx={{ color: "#666666" }}>
                            Task status:{" "}
                            <span
                              style={{
                                color:
                                  statusInfo.color === "success"
                                    ? "#4caf50"
                                    : statusInfo.color === "warning"
                                      ? "#ff9800"
                                      : "#f44336",
                              }}
                            >
                              {statusInfo.text}
                            </span>
                          </Typography>
                        </div>

                        {/* Completed on and Completed by */}
                        <div className="grid grid-cols-2 gap-48 mb-4">
                          <Typography variant="body1" sx={{ color: "#666666" }}>
                            Completed on:{" "}
                            <span style={{ color: "#000000" }}>
                              {item.completed_at
                                ? dateFormater(item.completed_at)
                                : "NA"}
                            </span>
                          </Typography>
                          <Typography variant="body1" sx={{ color: "#666666" }}>
                            Completed by:{" "}
                            <span style={{ color: "#000000" }}>
                              {item.completer?.name || "NA"}
                            </span>
                          </Typography>
                        </div>

                        {/* Description */}
                        <div className="mb-2">
                          <Typography
                            variant="body1"
                            className="mb-1"
                            sx={{ color: "#666666" }}
                          >
                            Description
                          </Typography>
                          <Typography
                            variant="body2"
                            className="text-justify leading-relaxed"
                            sx={{ color: "#000000", fontSize: "0.95rem" }}
                          >
                            {item.description || "No description available"}
                          </Typography>
                        </div>

                        {/* Complete Task Button - Only for open tasks */}
                        {item.status === 0 && (
                          <Button
                            variant="contained"
                            size="medium"
                            color="primary"
                            onClick={() => handleCompleteTask(item.id)}
                          >
                            Complete Task
                          </Button>
                        )}
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              );
            })
          ) : (
            <div className="flex flex-col items-center justify-center py-8">
              <Typography variant="h6" color="text.secondary">
                No timeline data available
              </Typography>
              <Typography variant="body2" color="text.secondary">
                There are no timeline entries for this task yet.
              </Typography>
            </div>
          )}
        </div>
      </CustomDrawer>

      <CustomModel
        modelData={
          isRequestChangeModal
            ? requestModalData
            : openAddPatientIdModal
              ? addIdModelData
              : dateModelData || {}
        }
        open={Boolean(
          openDateModal ||
          openAddPatientIdModal ||
          recordedDateModel ||
          isRequestChangeModal
        )}
        setOpen={
          openDateModal
            ? setOpenDateModal
            : recordedDateModel
              ? setRecordedDateModel
              : isRequestChangeModal && requestModalData
                ? setIsRequestChangeModal
                : setOpenAddPatientIdModal
        }
        modalInitialValues={
          isRequestChangeModal && requestModalData
            ? requestChangeInitial
            : openDateModal
              ? isApheresisModal
                ? { apheresisDateRange }
                : selectedLifeValue == "dead"
                  ? deadValue
                  : followUpValue
              : recordedDateModel
                ? recordedDate
                : patientIdValue
        }
        initialValuesValidationSchema={
          isRequestChangeModal && requestModalData
            ? requestModalDataSchema
            : openDateModal
              ? isApheresisModal
                ? apheresisDateRangeSchema
                : selectedLifeValue == "dead"
                  ? deathDateSchema
                  : lostToFollowUpSchema
              : recordedDateModel
                ? recordedDateSchema
                : addPatientIdSchema
        }
        handleModelValues={
          isRequestChangeModal
            ? handleRequestChangeSubmit
            : openDateModal
              ? isApheresisModal
                ? handleApheresisDateRangeSubmit // Use apheresis callback if flag is true
                : handlePatientLife // Use patient life callback else
              : recordedDateModel
                ? handleRecordingDate
                : handleAddPatientId
        }
        // handleModelValues={
        //   handleApheresisDateRangeSubmit ||
        //   (isRequestChangeModal
        //     ? handleRequestChangeSubmit
        //     : openDateModal
        //     ? handlePatientLife
        //     : recordedDateModel
        //     ? handleRecordingDate
        //     : handleAddPatientId)
        // }
        resistOverFlow={(openDateModal || recordedDateModel) ?? false} // make it conditional only for date one
        isLoadingBtn={buttonLoading}
        onChange={(e) => handleStatusChange(e)}
      />
      <ConfirmationModal
        open={openConfirmStausChange}
        setOpen={setOpenConfirmStausChange}
        errMessage={StatusChangeHeading}
        handleConfirmation={handleStatusChangeConfirmation}
      />

      {Boolean(editPatientModelOpen) && (
        <CustomModel
          modelData={editPatientModelData}
          open={Boolean(editPatientModelOpen)}
          setOpen={setEditPatientModelOpen}
          modalInitialValues={editSubjectPatient}
          initialValuesValidationSchema={editSubjectPhaseValidationSchema}
          handleModelValues={handleEditPatient}
          resistOverFlow={false} // make it conditional only for date one
        // isLoadingBtn={buttonLoading}
        />
      )}
       <ListAssignedPM  
              openEditorDrawer={openEditorDrawer}
              setOpenEditorDrawer={setOpenEditorDrawer}
              editorDrawerData={editorDrawerData} />
        <FilePreviewModal
        ModalTitle={"File Preview"}
        setOpen={setPreviewOpen}
        open={previewOpen}
        fileURL={filePreview}
      />
      <ChatModule />
    </div>
  );
};
